import { useCookieConfig } from 'hooks/useCookieConfig';
import { FormEndpointMapper, FormEndpointType } from './FormEndpoints';
import { Entry } from 'contentful';
import { IReseller } from 'services/dcs/bundle';

type EndpointFunctionArgs = [
  onSuccess: () => void,
  onError: () => void,
  onLeadError: () => void,
  contentfulReseller: Entry<IReseller>,
  orderTemplateCode?: string,
];

/**
 * A custom hook that returns a function to handle submitting form data to the specified endpoint.
 *
 * @param {FormEndpointType} endpointField - The type of the endpoint to which the form data should be submitted.
 * @returns {(formInputData: FormInputData) => Promise<any>} - A function that takes the form input data as a parameter and submits it to the appropriate endpoint.
 * Returns a Promise that resolves with the response from the endpoint.
 *
 * @typedef {Object} EndpointFunctionArgs - Represents the data sent to different endpoints defined in the FormEndpointMapper.
 *
 **/
export const useFormEndpointFunction = (endpointField: FormEndpointType) => {
  const cookieConfig = useCookieConfig();

  return (...args: EndpointFunctionArgs) => {
    const endpointFn = FormEndpointMapper[endpointField];
    return endpointFn(...args, cookieConfig);
  };
};
